// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListProjectsSkeleton-modulerow__UDGgk Skeleton-moduleSkeleton__Mlrfv";
var _2 = "GretaAIChatChatListProjectsSkeleton-moduleskeleton__EV428";
export { _1 as "row", _2 as "skeleton" }
